module.exports = __webpack_public_path__ + "static/media/gameGGJ.8c62a7ae.png";